import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    currentContact: null,
    error: null,
    loading: false
};

const contactPersonSlice = createSlice({
    name: 'contactPerson',
    initialState,
    reducers: {
        setCurrentContact: (state, action) => {
            state.currentContact = action.payload;
        },
        clearCurrentContact: (state) => {
            state.currentContact = null;
        },
        setError: (state, action) => {
            state.error = action.payload;
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        }
    }
});

export const {
    setCurrentContact,
    clearCurrentContact,
    setError,
    setLoading
} = contactPersonSlice.actions;

export default contactPersonSlice.reducer;